import { getToken } from "@roc-digital/mxm-base/logic";
import { useMethod } from "@roc-digital/ui-lib";
import React from "react";

const baseUrl = process.env.REACT_APP_ANALYTICER_API_URL;

export function useQuery<T>(cb: () => [string, ...any] |  undefined | false | null) {
  const query = runUseQuery(...(cb() || ['']));
  return {
    ...query,
    result: (query.result?.length ? query.result : []) as T[]
  }
}

function runUseQuery(sql: string, ...args: any) {
  const request = React.useMemo(() => {
    if(!sql) return false;

    return {sql, args, intColumns: []};
  }, [sql, ...args]);

  const query = useMethod(execQuery, {
    autoRun: request ? [request] : undefined
  });

  return query
}

export interface Query<T> {
  sql: string;
  args: any[];
  intColumns?:Array<keyof T>;
}


export async function execQuery<T>(query: Query<T>): Promise<T[]> {
  const request = await fetch(`${baseUrl}/data/query`, {
    method: 'POST',
    body: JSON.stringify(query),
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + await getToken()
    }
  });

  return (await request.json()) as T[];
}

export function getTop10ArticleForRange(from_ts: number, to_ts: number, count?: number) {
  const sql = `
    select * from (
        select
        (attr->'$.articleid')::text as article_id,
        count(*) as count,
        avg(start_ts) as avg
        from spans
        where start_ts > ${from_ts} and start_ts < ${to_ts}
        and label like 'article%'
        group by article_id
        order by count desc
        limit ${count || 10}
      ) data
    order by avg desc
  `

  return execQuery<{article_id: string, count: number}>({sql, args: [], intColumns: ['count']});
}

export function getEmailCampaignsForRange(from_ts: number, to_ts: number) {
  const sql = `select count, epoch_ms(time) as time from (
      select
        count(*) as count,
        min(start_time) as time,
      from visits
      where utm_medium = 'email'
      group by utm_campaign
      order by count desc
    ) campaigns where time > ${from_ts} and time < ${to_ts} and count > 100
    order by time
  `;

  return execQuery<{count: number, time: string}>({sql, args: [], intColumns: ['count']});
}

/**
 * Queries the database for a set of users. Returns the user_id as a javascript Set object containing all the user_ids.
 * 
 * This method can be used to quickly get a list of users and perform union/filtering operations with other set of users.
 */
export const extractUserSet = async (sql: string, args: any[]) => {
  const set = new Set<string>();
  const users = await execQuery<{ user_id: string }>({
    sql: sql,
    args: args
  });

  for(let user of users) {
    set.add(user.user_id);
  }

  return set;
}
